<template>
  <div class="service-info">
    <div class="content-nav-item">
                <!-- 下载中心 -->
                  <div class="search-box">
                    <input class="search-input" type="text" placeholder="输入关键字查找..."> <!-- 输入框 -->
                    <button type="submit" class="search-button">
                      <span style="font-weight: bold;">搜索</span>
                    </button>
                  </div>
                  <div class="guide">
                    <table class="pure-table pure-table-horizontal">
                      <thead>
                      <tr>
                        <th>文件名称</th>
                        <th>文件大小</th>
                        <th>下载</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr>
                        <td>吉光冰火系列使用指南</td>
                        <td>1.24M</td>
                        <td>
                          <a class="a_link" href="https://www.baidu.com/">
                            <img src="../../assets/img/download.png" @click="handleClick">
                          </a>
                        </td>
                      </tr>

                      <tr>
                        <td>炫碟系列使用指南</td>
                        <td>1.24M</td>
                        <td>
                          <a class="a_link" href="https://www.baidu.com/">
                            <img src="../../assets/img/download.png" @click="handleClick">
                          </a>
                        </td>
                      </tr>

                      <tr>
                        <td>飞瀑系列使用指南</td>
                        <td>1.24M</td>
                        <td>
                          <a class="a_link" href="https://www.baidu.com/">
                            <img src="../../assets/img/download.png" @click="handleClick">
                          </a>
                        </td>
                      </tr>

                      <tr>
                        <td>种苗系列使用指南</td>
                        <td>1.24M</td>
                        <td>
                          <a class="a_link" href="https://www.baidu.com/">
                            <img src="../../assets/img/download.png" @click="handleClick">
                          </a>
                        </td>
                      </tr>

                      <tr>
                        <td>城市阳台系列使用指南</td>
                        <td>1.24M</td>
                        <td>
                          <a class="a_link" href="https://www.baidu.com/">
                            <img src="../../assets/img/download.png" @click="handleClick">
                          </a>
                        </td>
                      </tr>

                      <tr>
                        <td>菌菇工厂系列使用指南</td>
                        <td>1.24M</td>
                        <td>
                          <a class="a_link" href="https://www.baidu.com/">
                            <img src="../../assets/img/download.png" @click="handleClick">
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
    </div>
  </div>
</template>

<script>
  import Banner_service from "../../components/Banner_service";
  export default {
    name: "down",
    components: {
      Banner_service,
    },
    data() {
      return {
        loading: false,
      };
    },
    created() {

    },
    mounted() {

    },
    // beforeDestroy() {
    //   localStorage.setItem('selectedNav', this.$store.state.selectedNav);
    // },
    methods: {
      loadData() {
        // window.location.reload()
      },
      handleClick() {
        window.open("https://www.baidu.com/");
      }
    }
  };
</script>

<style lang="scss" scoped>

  .service-info {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    /*position: relative;*/
    /*overflow: hidden;*/
    .content-nav-item {
      width: 88%;
      margin: 0 auto;
      /*display: flex;*/
      justify-content: flex-start;
      flex-wrap: wrap;
      //border: 1px solid blue;
      .search-box {
        margin-top: 50px;
        display: flex;
        align-items: center; /* 垂直居中 */
        justify-content: center; /* 水平居中 */
        position: relative;
        /*display: inline-block;*/
        width: 100%; /* 设置输入框的宽度 */
        height: 50px; /* 设置输入框的高度 */
        border: none; /* 去除默认边框 */
        outline: none; /* 去除点击时的外边框 */
        /*padding: 10px; !* 内部间距 *!*/
        /*background-color: #f4f4f4; !* 设置背景颜色 *!*/
        color: #999; /* 文本颜色 */
        font-size: 16px; /* 字体大小 */
        transition: all 0.3s ease; /* 添加过渡效果 */
      }
      .search-box input, .search-box button {
        width: 50%;
        height: 100%;
        margin: 0; /* 去除默认的边距 */
      }
      .search-box button {
        margin-left: 0; /* 去除按钮左侧的边距 */
        width: 10%;
        height: 100%;
        background-color: #ffffff;
        border: none;
        outline: none;
        color: #000000;
        font-size: 16px;
        border: 1px solid #ece7e7;
      }
      .guide {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 5%;
        padding-bottom: 5%;
        table {
          width: 100%;
          border-collapse: collapse;
          border-spacing: 0;
          /*font-size: x-large;*/
          /*font-family: "SourceHanSansCNNormal", Arial;*/

        }

        td,th {
          /*padding: 0;*/
          text-align: center;
          color: rgba(23, 23, 24, 0.6);
          .a_link {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 5%;
            }
          }
        }

        .pure-table {
          border-collapse: collapse;
          border-spacing: 0;
          empty-cells: show;
          border: 1px solid rgba(203, 203, 203, 0.5);
        }

        /*      .pure-table caption {
                color: #000;
                font: italic 85%/1 arial,sans-serif;
                padding: 1em 0;
                text-align: center;
              }*/

        .pure-table td,.pure-table th {
          border-left: 1px solid rgba(203, 203, 203, 0.5);
          border-width: 0 0 0 1px;
          font-size: inherit;
          margin: 0;
          overflow: visible;
          padding: 1.5em 1.5em;
        }

        .pure-table thead {
          background-color: #e0e0e0;
          color: rgba(23, 23, 24, 0.5);
          vertical-align: bottom;
        }

        .pure-table td {
          background-color: transparent;
        }
        tr:nth-child(even) {
          background-color: #f2f2f2; /*奇数行为白色背景*/
        }
        .pure-table-horizontal td,.pure-table-horizontal th {
          border-width: 0 0 1px 0;
          border-bottom: 1px solid rgba(203, 203, 203, 0.5);
        }

        .pure-table-horizontal tbody>tr:last-child>td {
          border-bottom-width: 0;
        }
      }
    }
  }
</style>
